import React  from 'react'
import DropDown from '../dropdown';
import { AllocationAndStrategy } from '../../../api/services/next'
import { useMemo } from 'react';

const AllocationsDropDown = ({...rest}) => {
    const spec = useMemo(() => ({
        IsActive: true,
    }), [] )
    return <DropDown api={AllocationAndStrategy.GetAllocations} spec={spec} textField="Name" valueField="Id"  {...rest}/>
}

export default AllocationsDropDown

